import React from "react"
import TwoColWrapper from "../technical/TwoColWrapper"

// TODO: FadeIn for LI

const TextWithListBlock = ({ block }) => {
  return (
    <TwoColWrapper block={block}>
      <h2>
        <span>{block.list_headline}</span>
      </h2>
      <ul className="kn-feature-list">
        {block.list?.length > 0 &&
          block.list.map((item, index) => (
            <li key={index}>
              {item.title}
              <br />
              <span className="text-muted">{item.subtitle}</span>
            </li>
          ))}
      </ul>
    </TwoColWrapper>
  )
}

export default TextWithListBlock
